import React from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import { LegalContent } from '../Components/Legal/LegalContent';
import { LegalNav } from '../Components/Legal/LegalNav';

const LegalNotices = () => {
  sendGAPageview({ hitType: 'pageview', page: '/Legal', title: 'Legal Notices' });

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Legal Notices</title>
        <meta
          name="description"
          content="Explore DISGENET's legal notices, stay informed about your rights and responsibilities when using our platform."
        />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/Legal" />
        <meta property="og:title" content="DISGENET: Legal Notices" />
        <meta
          property="og:description"
          content="Learn about the legal notices, terms, and conditions for using DISGENET, ensuring that you're informed about your rights and responsibilities."
        />
      </Helmet>
      <CommonHeader />
      <section>
        <link rel="canonical" href="/Legal" />
        <div className="container txt-contenido">
          <h2 className="mt-8">Legal Notices</h2>
          <LegalNav />
          <LegalContent />
        </div>
      </section>
    </React.Fragment>
  );
};

export default LegalNotices;
